export default [
  {
    path: '/v2/payment/khqr-attempts',
    name: 'khqr-payment',
    meta: { requiresAuth: true, permission: 'view-khqr-payment' },
    component: () => import('./views/Index.vue')
  }
]
